import React from 'react';
import $ from 'jquery';
import {Link} from 'react-router-dom';
import RouteMap from './routemapview';
import InfraTable from './infratable';
import PtResult from './ptresult';
import PrintButton from '../print_button';
import ReactTooltip from 'react-tooltip';

export default class AddressInfraViewPage extends React.Component {
	constructor(props) {
		super(props);
		this.xhr = null;
		this.lpobj = window.datastore.lps.get(this.props.match.params.placeid)
		this.state = {
				loadingRoutes: true,
				recievedInfraResult: false,
				showMap: false,
				placename: this.lpobj.get('name')
		}
		this.handleMapButtonClick = this.handleMapButtonClick.bind(this);
		
		//var lpmodel = this.props.lps.get(this.props.id);
	}
	componentWillMount() {
		var comp = this
		if (this.lpobj.get('targetroutes') === null) {
			this.xhr = $.ajax({
        	    url: "routes",
        	    data: { 
        	        "x": comp.lpobj.get('xy')[0], 
        	        "y": comp.lpobj.get('xy')[1]
        	    },
        	    type: "GET",
        	    beforeSend: function () {
        	    	//$("body").css("cursor", "progress");
        	    },
        	    success: function(response) {
        	    	//alert(response)
        	    	comp.lpobj.set({targetroutes: response.infra});
        	    	comp.lpobj.set({ptquali: response.ptquali});
			comp.lpobj.set({traveltimescenter: response.traveltimes_to_center});
        	    	comp.setState({
        	    		loadingRoutes: false,
        				recievedInfraResult: true,
        				routes: comp.lpobj.get('targetroutes'),
					traveltimescenter: comp.lpobj.get('traveltimescenter'),
        				placename: comp.lpobj.get('name'),
        				ptquali: comp.lpobj.get('ptquali'),
        				xy: comp.lpobj.get('xy')
        	  	    });
        	    },
        	    error: function() {
        	    	comp.setState({
        	    		loadingRoutes: false,
        				recievedInfraResult: false
        	  	    });
        	    },
        	    complete: function(xhr) {
        	    	//$("body").css("cursor", "default");
        	    }
        	});
		} else {
			comp.setState({
	    		loadingRoutes: false,
				recievedInfraResult: true,
				routes: comp.lpobj.get('targetroutes'),
				traveltimescenter: comp.lpobj.get('traveltimescenter'),
				placename: comp.lpobj.get('name'),
				ptquali: comp.lpobj.get('ptquali'),
				xy: comp.lpobj.get('xy')
	  	    });
		}
	  }
		
	componentWillUnmount() {
		if (this.xhr) {
			this.xhr.abort()
		}
	}
	
	handleMapButtonClick() {
		if (this.state.showMap === false) {
			this.setState({
				showMap: true
			})
		}
		else {
			this.setState({
				showMap: false
			})
		}
		}
	  render() {
		  
		    function showTheMap (state, props) {
		    	if (state.showMap) {
		    		return (<RouteMap routes={state.routes} ptquali={state.ptquali} xy={state.xy} />)
		    	}
		    	else {
		    		return (<AddressInfraViewResults loadingRoutes={state.loadingRoutes} 
		    		recievedInfraResult={state.recievedInfraResult} routes={state.routes} traveltimescenter={state.traveltimescenter} ptquali={state.ptquali} />)
		    	}
		    }
		    
		    
		    return (
		    		<div className="pagecontainer">
				    <nav className="navbar navbar-default">
					  <div className="container-fluid header">
					  <div>
					    <ol className="breadcrumb">
					    {this.props.match.params.placeid === "2" ? <li className=""><Link to={"wohnstandorte/1/addressmap"}>Zu Wohnstandort 1</Link></li> : ''}
					    {this.props.match.params.placeid === "1" ? <li className=""><a href="/">Start</a></li> : ''}
					    <li className=""><Link to={"/wohnstandorte/"+this.props.match.params.placeid+"/addressmap"}>{this.props.match.params.placeid === "2" ? "Vergleichsstandort" : "Wohnstandort"}</Link></li>
					    <li className="active">Infrastruktur</li>
					    <li className="not-active">Wohnkosten</li>
					    <li className="not-active">Mobilität</li>
					    {this.props.match.params.placeid === "2" ? <li className="not-active">Vergleich</li> : <li className="not-active">Ergebnis</li>}
					    {this.props.match.params.placeid === "1" ? <li className="not-active">Vergleichsstandort</li> : ''}
					    </ol>
				    </div>
					  </div>
					</nav>
		    		<div className={this.state.showMap == false ? "container-fluid" : "container-fluid full-height"}>
		    		
		    		
		    		<h4>{this.state.placename}</h4>
		    		{this.props.match.params.placeid === "2" ? <h4>(Vergleichsstandort)</h4> : ''}
		    		
		    		<h3>Versorgungsqualität</h3>
		    		{this.state.showMap == false ? <span className="help-block">Hier wird die Erreichbarkeit des Standorts - im Hinblick auf fußläufige Wege - von verschiedenen 
		    		Infrastruktureinrichtungen dargestellt. Die Nutzung des öffentlichen Verkehrs und Erledigungen zu Fuß sparen Geld und schonen die Umwelt.</span> : ''}
		    		<hr></hr>
		    		{showTheMap(this.state, this.props)}
		    		<hr></hr>
		    		<div className="btn-infra-controls">
		    		<button onClick={this.handleMapButtonClick} className={this.state.recievedInfraResult == true ? 'btn btn-success left-button' : 'btn btn-success left-button disabled hidden' }>{this.state.showMap == false ? 'Auf Karte anzeigen' : 'Karte schließen'}</button>
		    		<PrintButton enabled={this.state.recievedInfraResult}/>
		    		<Link to={"/wohnstandorte/"+this.props.match.params.placeid+"/wohnkosten"}><button className={this.state.recievedInfraResult == true ? "btn btn-default btn-primary right-button" : "btn btn-default btn-primary right-button disabled hidden"}>WEITER</button></Link>
		    		</div>
		    		 <div className="help-block smalltext">
					    Sämtliche Daten und Informationen wurden sorgfältig ermittelt. 
					    Es kann jedoch keine Garantie für die Richtigkeit, 
					    Vollständigkeit und Aktualität der Angaben übernommen werden. Fußwegrouten sind letztlich Schätzungen und dienen nicht der Navigation. Datenquellen: Land Oberösterreich, OSM, GIP, VAO, basemap.at, iSPACE
					    </div>
					    <p className="small">Analysen entwickelt von <a href="https://ispace.researchstudio.at/" target="_blank">RSA Studio iSPACE</a>. Basierend auf <a href="http://www.moreco.at" target="_blank">moreco.at</a></p>
		    		</div>
		    		</div>
		    		
		    );
		  }
}

class AddressInfraViewResults extends React.Component {
	constructor(props) {
		super(props);
	}
	render () {
		if (this.props.loadingRoutes === false && this.props.recievedInfraResult === true) {
			return (
					<div className="row">
		    		  <div className="col-sm-8">
		    		  <h4>Infrastruktur</h4>
		    		  <InfraRoutesResults routes={this.props.routes} traveltimescenter={this.props.traveltimescenter}/>
		    		 
		    		  </div>
		    		  <div className="col-sm-3"><h4>Öff. Verkehr</h4>
		    		  <PtResult ptquali={this.props.ptquali} />
		    		  </div>
		    		</div>	
			)
		} else if (this.props.loadingRoutes === false && this.props.recievedInfraResult === false) {
			return (
					<div>
		    		Für diesen Standort konnten keine Daten ermittelt werden.
		    		</div>	
			)
		} else {
			
			return (
					<div>
		    		Daten werden ermittelt...
		    		</div>
			)
			
		}
		
	}	
}

class InfraRoutesResults extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (
				<div>
				 <InfraTable routes={this.props.routes} traveltimescenter={this.props.traveltimescenter}/>	
				</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/infraresults/addressinfraresultview.js